import logo from "../../assets/images/logo/logo.png";

const FooterTwo = () => {
  return (
    <div className="footer-style-2 ptb--30 bg_image " data-black-overlay="6">
      <div className="wrapper plr--50 plr_sm--20">
        <div className="row align-items-center justify-content-between">
          <div className="col-lg-4 col-md-6 col-sm-6 col-12">
            <div className="inner">
              <div className="logo text-center text-sm-left mb_sm--20">
                <a href="/home-one"></a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-12 col-sm-12 col-12">
            <div className="inner text-center mt_md--20 mt_sm--20">
              <div className="text">
                <p>
                  Copyright © 2025 Grand Maple Properties. All Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterTwo;
